//* Import react and types
import React from "react";

//* Import components from react-bootstrap
import { Container, Row, Col } from "react-bootstrap";

//* Import icons from lucide-react
import { Briefcase, Users, User, UserCheck } from "lucide-react";

//* Import types from types
import type { CoursesDetails } from "../../../../hooks/courses/types/type";

//*type for the structure
type CourseHeaderProps = {
  coursesDetails: CoursesDetails;
};

export const CourseHeader: React.FC<CourseHeaderProps> = React.memo(
  ({ coursesDetails }) => {
    return (
      <div className="bg-light py-4 border-bottom">
        <Container>
          <Row className="align-items-center">
            <Col md={8}>
              <h2 className="mb-1 text-dark">{coursesDetails.name}</h2>
              <p className="text-muted mb-0">
                {coursesDetails.description || "Sem descrição disponível."}
              </p>
            </Col>
            <Col md={4} className="text-md-end mt-3 mt-md-0">
              <div className="d-flex justify-content-md-end align-items-center mb-2">
                <Briefcase
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Organização:</strong>{" "}
                  {coursesDetails.organization.name}
                </span>
              </div>
              <div className="d-flex justify-content-md-end align-items-center">
                <Users
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Total de Turmas:</strong>{" "}
                  {coursesDetails.totalTeams || 0}
                </span>
              </div>
              <div className="d-flex justify-content-md-end align-items-center mt-1">
                <User
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Total de Alunos:</strong>{" "}
                  {coursesDetails.totalStudents || 0}
                </span>
              </div>
              <div className="d-flex justify-content-md-end align-items-center mt-1">
                <UserCheck
                  className="me-2 text-primary"
                  size={20}
                  aria-hidden="true"
                />
                <span className="text-dark">
                  <strong>Alunos Ativos:</strong>{" "}
                  {coursesDetails.totalActiveStudents || 0}
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
);
